import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getResubscribePackagesList = createAsyncThunk(
  "resubscribe/getResubscribePackagesList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.getResubscribePackagesList.url,
        method: API.members.getResubscribePackagesList.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const resubscribePackage = createAsyncThunk(
  "resubscribe/resubscribePackage",
  async (
    params: {
      packageId: string;
      signature: string;
      memberCCInfoId: string;
      familyMember: any[];
      slots: Array<{
        parkingId: string;
        noOfVehicle: number;
        notifyParking: boolean;
      }>;

      voucherCode: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.resubscribePackage.url,
        method: API.members.resubscribePackage.method,
        data: params,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
